import { FunctionComponent } from 'react';
import { Button, Div, Divider, GridBag, Headline, Icon, Title, Image } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { createAuthenticationUrl } from '../../../utils';
import { useSelector } from 'react-redux';

import classes from './Login.module.css';
import teliaCroppedLogo from '../../../assets/images/shiny-pebble-cropped2x.svg';
import { RootState } from '../../../store/reducers';
import { useLocation } from 'react-router';

interface LoginProps {}

const Login: FunctionComponent<LoginProps> = () => {
  const { t } = useTranslation('authentication');

  const requestedPath = useSelector((state: RootState) => state.authentication.requestedPath);

  const history = useHistory();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const existingUserParam = searchParams.get('existingUser');

  const handleNewUserClick = (): void => {
    history.push('/authentication/new-login');
  };

  const handleLoginClick = (): void => {
    window.location.href = createAuthenticationUrl(requestedPath || undefined);
  };

  return (
    <Div className={classes.login} data-testid="login-component">
      {existingUserParam !== 'true' && (
        <>
          <Div margin={{ vertical: 'xlg' }} padding={{ top: 'md' }}>
            <GridBag>
              <GridBag.Item sm={2} alignTextToRight>
                <Icon name="getting-started" size="xlg" />
              </GridBag.Item>
              <GridBag.Item sm={8} md={5}>
                <Headline size="md" block>
                  {t('LoginComponent.newUserTitle')}
                </Headline>
                <Title size="xs" block margin={{ vertical: 'md' }} style={{ lineHeight: '28px' }}>
                  {t('LoginComponent.newUserInstruction')}
                </Title>
                <Button size="lg" iconOnRight iconName="chevron-right" onClick={handleNewUserClick}>
                  {t('LoginComponent.newUserButton')}
                </Button>
              </GridBag.Item>
            </GridBag>
          </Div>
          <Div padding={{ horizontal: 'xlg' }}>
            <Divider />
          </Div>
        </>
      )}
      <Div margin={{ vertical: 'xlg' }} padding={{ top: 'md' }}>
        <GridBag>
          <GridBag.Item sm={2} alignTextToRight>
            <Icon name="login" size="xlg" />
          </GridBag.Item>
          <GridBag.Item sm={8} md={5}>
            <Headline size="md" block>
              {t('LoginComponent.loginTitle')}
            </Headline>
            <Title size="xs" block margin={{ vertical: 'md' }} style={{ lineHeight: '28px' }}>
              {t('LoginComponent.loginInstruction')}
            </Title>
            <Button size="lg" variant="secondary" iconOnRight iconName="chevron-right" onClick={handleLoginClick}>
              {t('LoginComponent.loginButton')}
            </Button>
          </GridBag.Item>
        </GridBag>
      </Div>
      <Div className={classes['telia-logo']}>
        <Image src={teliaCroppedLogo} alt="telia image" />
      </Div>
    </Div>
  );
};

export default Login;
